import type { TabsProps } from "antd";
import { EquipmentLiveMap } from "@/modules/equipment/components/EquipmentLiveMap";
import { OrgUserFormModal } from "@/modules/organization-users/components/OrgUserFormModal";
import { OrgUsersTable } from "@/modules/organization-users/components/OrgUsersTable";
import { OrgDevicesTab } from "@/modules/organizations/components/OrgDevicesTab";
import { OrgEquipmentTab } from "@/modules/organizations/components/OrgEquipmentTab";
import { ComingSoonTab } from "./ComingSoonTab";
import { OrgAttendanceReportTab } from "./OrgAttendanceReportTab";
import { OrgAttendanceTab } from "./OrgAttendanceTab";
import { OrgBrigadesTab } from "./OrgBrigadesTab";
import { OrgChildrenTab } from "./OrgChildrenTab";
import { OrgCrossAccessTab } from "./OrgCrossAccessTab";
import { OrgFaceEnrollmentTab } from "./OrgFaceEnrollmentTab";
import { OrgGpsDevicesTab } from "./OrgGpsDevicesTab";
import { OrgStaffTab } from "./OrgStaffTab";
import { OrgTerritoriesTab } from "./OrgTerritoriesTab";

export type OrgDetailTabKey =
	| "children"
	| "cross-access"
	| "users"
	| "devices"
	| "faceid"
	| "cameras"
	| "employees"
	| "brigades"
	| "equipment"
	| "live-gps"
	| "territories"
	| "attendance"
	| "attendance-report"
	| "gps-devices";

export function buildOrgDetailTabs(organizationId: string): TabsProps["items"] {
	return [
		{
			key: "children" satisfies OrgDetailTabKey,
			label: <span>Quyi tashkilotlar</span>,
			children: <OrgChildrenTab organizationId={organizationId} />,
		},
		{
			key: "cross-access" satisfies OrgDetailTabKey,
			label: <span>Kirish huquqlari</span>,
			children: <OrgCrossAccessTab organizationId={organizationId} />,
		},
		{
			key: "users" satisfies OrgDetailTabKey,
			label: <span>Foydalanuvchilar</span>,
			children: (
				<>
					<OrgUsersTable organizationId={organizationId} />
					<OrgUserFormModal organizationId={organizationId} />
				</>
			),
		},
		{
			key: "devices" satisfies OrgDetailTabKey,
			label: <span>Qurilmalar</span>,
			children: <OrgDevicesTab organizationId={organizationId} />,
		},

		{
			key: "faceid" satisfies OrgDetailTabKey,
			label: <span>Yuz ro'yxatga olish</span>,
			children: <OrgFaceEnrollmentTab organizationId={organizationId} />,
		},
		{
			key: "cameras" satisfies OrgDetailTabKey,
			label: <span>Kameralarni ko'rish</span>,
			children: <ComingSoonTab title="Kameralarni ko'rish va sozlash" />,
		},
		{
			key: "employees" satisfies OrgDetailTabKey,
			label: <span>Xodimlar ro'yhati</span>,
			children: <OrgStaffTab organizationId={organizationId} />,
		},
		{
			key: "brigades" satisfies OrgDetailTabKey,
			label: <span>Brigadalar</span>,
			children: <OrgBrigadesTab organizationId={organizationId} />,
		},
		{
			key: "equipment" satisfies OrgDetailTabKey,
			label: <span>Texnikalar</span>,
			children: <OrgEquipmentTab organizationId={organizationId} />,
		},
		{
			key: "gps-devices" satisfies OrgDetailTabKey,
			label: <span>GPS qurilmalar</span>,
			children: <OrgGpsDevicesTab organizationId={organizationId} />,
		},
		{
			key: "live-gps" satisfies OrgDetailTabKey,
			label: <span>GPS Live Tracking</span>,
			children: <EquipmentLiveMap organizationId={organizationId} />,
		},
		{
			key: "territories" satisfies OrgDetailTabKey,
			label: <span>Hududlar</span>,
			children: <OrgTerritoriesTab organizationId={organizationId} />,
		},
		{
			key: "attendance" satisfies OrgDetailTabKey,
			label: <span>Davomat qo&apos;shish</span>,
			children: <OrgAttendanceTab organizationId={organizationId} />,
		},
		{
			key: "attendance-report" satisfies OrgDetailTabKey,
			label: <span>Davomat hisoboti</span>,
			children: <OrgAttendanceReportTab organizationId={organizationId} />,
		},
	];
}
